import { observer } from "mobx-react-lite";
import React from "react";
//import { getTabs } from "../../utils/functions";
import SelectNuvama from "../SelectNuvama/SelectNuvama";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import PerformanceStore from "../../store/PerformanceStore";
import downArrowBlack from "../../assets/images/svg/downArrowBlack.svg";
import PerformanceTabs from "./PerformanceTabs";

const PagesTabs = ({
  tabsDataProp,
  handleTab,
  selectedTab,
  setOpenFamilyModal,
  selectedMember,
  selectedIndex,
}) => {
  const withNuvama = UserStore.withNuvama;
  const withOthers = UserStore.withOthers;

  const handleWealth = () => {
    PerformanceStore.setCurrentLoader("fullScreen");
    AuthStore.updateLoadingFullScreen(true);
    PerformanceStore.setAssetClass({ id: "all", name: "Overall" });
    PerformanceStore.onFirstLoad();
    UserStore.getReportsPersistData();
    PerformanceStore.setPerformanceLastTabToInitial();
    PerformanceStore.setData("selectedEvent", {
      eventName: "Event not selected",
      id: null,
    });
  };
  const handleClientSelection = () => {
    PerformanceStore.setCurrentLoader("fullScreen");
    AuthStore.updateLoadingFullScreen(true);
    PerformanceStore.onFirstLoad();
  };

  return (
    <>
      <div className="tabs_part">
        {/* <div className="tabs port_tabs performance_tab">
          <ul>
            {tabsDataProp?.map((tabsData) => (
              <li
                className={
                  selectedTab.id === tabsData?.id
                    ? "is-active"
                    : "performance-button-animation"
                }
                onClick={() => handleTab(tabsData)}
              >
                <button className="tab-name">{getTabs(tabsData?.name)}</button>
              </li>
            ))}
          </ul>
        </div> */}

        <PerformanceTabs
          tabs={tabsDataProp}
          selectedTab={selectedTab}
          selectedIndex={selectedIndex}
          handleTab={(props) => handleTab(props)}
        />
        <SelectNuvama
          type={
            PerformanceStore.selectedAssetClass.id !== 6 ? "all" : "onlybtn"
          }
          withNuvama={withNuvama}
          withOthers={withOthers}
          handleWealth={(title) => handleWealth(title)}
          handleClientSelection={() => handleClientSelection()}
          setOpenFamilyModal={() => setOpenFamilyModal(true)}
          selectedMember={selectedMember}
          memberDropdownClass="analytics-members-dropdown"
          memberDropdownTextClass="analytics-members-dropdown-text"
          downArrowIcon={downArrowBlack}
        />
      </div>
    </>
  );
};

export default observer(PagesTabs);
